<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
        <div class="d-sm-flex align-items-center">
          <router-link v-if="checkPermission('AddPaiement')"
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            to="/ajouter-paiement-recette">
            Nouveau Paiement
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          </router-link>
        </div>
        <div class="d-flex align-items-center">
          <Field name="montant" v-model="lemontant" aria-disabled="true" type="text" disabled
            class="form-control text-center text-black shadow-none fs-md-15 text-black" />
        </div>
        <div class="d-flex align-items-center">
          <button type="button" @click="getPoint()" v-if="valideEtape3"
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none">
            <i class="flaticon-download position-relative ms-5 fs-12"></i>
            Exporter
          </button>
          <button
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            type="button" v-if="!valideEtape3" disabled>
            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            <span class="visually-hidden">Chargement...</span>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-3 col-xm-12 col-sm-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Mot clé
                </label>
                <Field v-model="motCle" name="mot" type="text" aria-disabled="true"
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Recherche par mot clé" />
                <ErrorMessage name="mot" class="text-danger" />
              </div>
            </div>
            <div class="col-md-3 col-xm-12 col-sm-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Agent <span class="text-danger">*</span>
                </label>
                <Field name="agent" v-slot="{ field }" v-model="agent"
                  class="form-control shadow-none fs-md-15 text-black">
                  <Multiselect v-model="field.value" v-bind="field" :options="agentOptions" :searchable="true"
                    noResultText="Aucun enregistrement trouvé" placeholder="Rechercher un percepteur" />
                </Field>
                <ErrorMessage name="agent" class="text-danger" />
              </div>
            </div>
  
            <div class="col-md-3 col-sm-6col-xm-12 col-sm-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date début <span class="text-danger">*</span>
                </label>
                <Field name="dateDebut" type="date" v-model="dateDebut"
                  class="form-control shadow-none fs-md-15 text-black" />
                <ErrorMessage name="dateDebut" class="text-danger" />
              </div>
            </div>
  
            <div class="col-md-3 col-xm-12 col-sm-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date fin <span class="text-danger">*</span>
                </label>
                <Field name="dateFin" v-model="dateFin" type="date"
                  class="form-control shadow-none fs-md-15 text-black" />
                <ErrorMessage name="dateFin" class="text-danger" />
              </div>
            </div>
  
  
          </div>
        </div>
        <hr />
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  #
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Date
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Usager
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Motif recette
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Taux 
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Quantité
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  montant
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Place
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Acteur
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ret, index) in retours" :key="index">
                <td class="shadow-none lh-1 fw-medium text-primary">
                  {{ ret.refPaiement }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-primary">
                  {{ format_date(ret.datePaiement, 'YYYY-MM-DD HH:ii') }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-primary">
                  {{ ret.usager }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-primary">
                  {{ ret.motif }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ ret.taux + " "+ ret.frequence }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ ret.duree }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ ret.montant }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ret.contrat ? ret.contrat?.codeemp?.ncode_emp + " "+ret?.contrat?.usagers : "" }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ ret?.userCreation?.nomComplet }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-end pe-0 sm">
                  <div class="dropdown">
                    <span class="badge text-white bg-secondary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                      aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                    </span>
                    <ul class="dropdown-menu">
                      <li>
                        <a @click="openNewWindow(ret)" type="button" class="dropdown-item d-flex align-items-center">
                          <i class="flaticon-send lh-1 me-8 position-relative top-1"></i>
                          Reçu de paiement
                        </a>
                      </li>
                      <li v-if="checkPermission('AnnulationPaiementRecette')">
                        <a href="javascript:void(0);" data-bs-target="#create-task" data-bs-toggle="modal"
                          @click="openModal(ret.refPaiement)" class="dropdown-item d-flex align-items-center">
                          <i class="flaticon-close lh-1 me-8 position-relative top-1"></i> Annulation
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal fade" id="create-task" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h6 class="modal-title">Voulez-vous annuler cette facture ?</h6>
                <button type="button" id="close-modal" class="btn-close" data-bs-dismiss="modal"
                  aria-label="Close"></button>
              </div>
              <div class="modal-body px-4">
                <Form ref="annulationForm" @submit="soumettre" :validation-schema="annulationSchema">
                  <div class="row gy-2">
                    <div class="col-md-4-3">
                      <Field name="id" v-model="paiementId" hidden
                        class="form-control shadow-none rounded-0 text-black" />
                    </div>
                    <div class="col-md-4-3">
                      <label class="d-block fw-semibold mb-10">
                        Motif<span class="text-danger"></span>
                      </label>
                      <Field name="motifAnnulation" as="textarea" placeholder="Entrer le motif d'annulation"
                        class="form-control shadow-none rounded-0 text-black" />
                      <ErrorMessage name="motifAnnulation" class="text-danger" />
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">Annuler</button>
                    <button type="button" class="btn btn-danger" aria-label="Close" data-bs-dismiss="modal">
                      Fermer
                    </button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
            @paginate="handlePaginate" />
        </div>
      </div>
    </div>
  </template>
  <script lang="ts">
  import { ref, defineComponent, onMounted, watch } from "vue";
  import { Form, Field, ErrorMessage } from "vee-validate";
  import {
    showModal,
    suppression,
    separateur,
    format_Date,
    format_date,
    supprimerElement,
    error,
    dateActuelle,
    success,
    checkPermission,
    getUrlApiForFiles,
  } from "@/utils/utils";
  import { Contrat } from "@/models/Contrat";
  import ApiService from "@/services/ApiService";
  import { Option } from "@/models/Option";
  import PaginationComponent from "@/components/Utilities/Pagination.vue";
  import JwtService from "@/services/JwtService";
  import Multiselect from "@vueform/multiselect";
  import axios from "axios";
  import Swal from "sweetalert2";
  import * as Yup from 'yup';
  
  export default defineComponent({
    name: "ListePaiementAutreRecette",
    components: {
      PaginationComponent,
      Field,
      Form,
      ErrorMessage,
      Multiselect,
    },
    setup: () => {
      // BEGIN PAGINATE
      const searchTerm = ref("");
      const page = ref(1);
      const totalPages = ref(0);
      const limit = ref(10);
      const totalElements = ref(0);
      const secteursOptions = ref<Array<Option>>([]);
      const motCle = ref("");
      const dateFin = ref(dateActuelle());
      const dateDebut = ref(dateActuelle());
      const lemontant = ref("0");
      const donn = ref();
      const annulationForm = ref();
  
      const annulationSchema = Yup.object().shape({
        motifAnnulation: Yup.string().required("Le motif est obligatoire"),
      });
      // END PAGINATE
      const handlePaginate = ({ page_, limit_ }) => {
        try {
          page.value = page_;
          limit.value = limit_;
          actionRecherche(page_, limit_);
        } catch (error) {
          //
        }
      };
      const getUser = async () => {
        try {
          const response = await axios.get("/tout/users");
          const donnee = response.data.data;
          agentOptions.value = donnee.map((agent) => ({
            value: agent.id,
            label: agent.nomComplet,
          }));
        } catch (error) {
          //
        }
      };
      function triggerButtonClick(buttonId: string) {
        const button = document.getElementById(buttonId) as HTMLButtonElement;
        if (button) {
          button.click(); // Simule un clic
        } else {
          console.error(`Button with ID "${buttonId}" not found.`);
        }
      }
      const soumettre = async (values, { resetForm }) => {
        values["id"] = paiementId.value;
        try {
          const response = await axios.post(`annulation/autre/recette/paiement`, values);
          if (response.data.code == 201) {
            success(response.data.message);
            await actionRecherche(1, 10);
            resetForm();
            triggerButtonClick("close-modal");
          }
        } catch (err) {
          if (axios.isAxiosError(err) && err.response) {
            error(err.response.data.message || err.message);
          } else {
            if (err instanceof Error) {
              error(err.message);
            } else {
              error(String(err));
            }
          }
        }
      };
  
  
      const valideEtape3 = ref(true);
      const recharger = () => {
        actionRecherche(page.value, limit.value);
      };
      const agent = ref();
      const agentOptions = ref();
      const statut = ref();
      const statutOptions = ref();
      const retours: any = ref<Array<any>>([]);
  
      const getRetourById = async (key) => {
        try {
          const response = await axios.get(
            `recuperation/des/informations/de/detours/${key}`
          );
          const donnee = response.data;
        } catch (error) {
          //
        }
      };
  
      const paiementId = ref<number | null>(null);
      const openModal = (id: number) => {
        paiementId.value = id;
      };
  
      const openAndPrint = (url: string) => {
        const newWindow = window.open(url, "_blank");
        if (newWindow) {
          newWindow.onload = () => {
            newWindow.print();
          };
        } else {
          console.error("Impossible d'ouvrir la fenêtre");
        }
      };
      function openNewWindow(data: any, dossier = "Recu") {
        openAndPrint(getUrlApiForFiles(dossier, data.refPaiement + ".pdf"));
      }
      const actionRecherche = async (page = 1, limi = 10, searchTerm = "") => {
        const element = {
          dateDebut:
            (dateDebut.value ? dateDebut.value : dateActuelle()) + " 00:00:00",
          dateFin: (dateFin.value ? dateFin.value : dateActuelle()) + " 23:59:59",
          motCle: motCle.value,
          recherche: motCle.value,
          acteur: agent.value,
          statut: statut.value,
          page: page,
          totalPages: totalPages.value,
          limit: limi,
          totalElements: totalElements.value,
          mot: searchTerm,
        };
        donn.value = element;
        try {
          const response = await axios.post("listePaiement/autre/recette", element);
          retours.value = (response.data.data.data).entities;
          totalPages.value = response.data.data.totalPages;
          limit.value = response.data.data.limit;
          totalElements.value = response.data.data.totalElements;
          lemontant.value = separateur(response.data.data.montant) + " (FCFA)";
        } catch (err) {
          if (axios.isAxiosError(err) && err.response) {
            error(err.response.data.message || err.message);
          } else {
            if (err instanceof Error) {
              error(err.message);
            } else {
              error(String(err));
            }
          }
        }
      };
  
      const getPoint = async () => {
        try {
          valideEtape3.value = false;
          donn.value = {
            dateDebut:
              (dateDebut.value ? dateDebut.value : dateActuelle()) + " 00:00:00",
            dateFin:
              (dateFin.value ? dateFin.value : dateActuelle()) + " 23:59:59",
            motCle: motCle.value,
            acteur: agent.value,
          };
          const response = await axios.post("/getPoint", donn.value);
          openNewWindow({ reference: response.data.data }, "Point");
          valideEtape3.value = true;
        } catch (error) {
          // error("Erreur");
        }
      };
      watch(motCle, async (newValue, oldValue) => {
        page.value = 1;
        limit.value = 10;
        totalPages.value = 0;
        totalElements.value = 0;
        motCle.value = newValue;
        await actionRecherche(page.value, limit.value);
      });
      watch(dateFin, (newValue, oldValue) => {
        page.value = 1;
        limit.value = 10;
        totalPages.value = 0;
        totalElements.value = 0;
        dateFin.value = newValue;
        actionRecherche(page.value, limit.value);
      });
      watch(agent, (newValue, oldValue) => {
        page.value = 1;
        limit.value = 10;
        totalPages.value = 0;
        totalElements.value = 0;
        agent.value = newValue;
        actionRecherche(page.value, limit.value);
      });
      watch(statut, (newValue, oldValue) => {
        page.value = 1;
        limit.value = 10;
        totalPages.value = 0;
        totalElements.value = 0;
        statut.value = newValue;
        actionRecherche(page.value, limit.value);
      });
      watch(dateDebut, (newValue, oldValue) => {
        page.value = 1;
        limit.value = 10;
        totalPages.value = 0;
        totalElements.value = 0;
        dateDebut.value = newValue;
        actionRecherche(page.value, limit.value);
      });
      const supprime = async (id) => {
        Swal.fire({
          text: `Vous êtes sur le point de supprimer le retour n° ${id}. Etes-vous sûr ?`,
          icon: "warning",
          buttonsStyling: true,
          showCancelButton: true,
          confirmButtonText: "Supprimer",
          cancelButtonText: `Annuler`,
          heightAuto: false,
          customClass: {
            confirmButton: "btn btn-danger",
          },
        })
          .then((result) => {
            if (result.isConfirmed) {
              ApiService.delete(`delete/retour/${id}`)
                .then(async ({ data }) => {
                  if (data.code == 200) {
                    success(data.message);
                    await actionRecherche(1, 10);
                  }
                })
                .catch(async ({ response }) => {
                  error(response.message);
                });
            }
          })
          .catch(async ({ response }) => {
            error(response.message);
          });
      };
      onMounted(async () => {
        await actionRecherche(1, 10);
        await getUser();
      });
      return {
        dateDebut,
        dateFin,
        suppression,
        recharger,
        page,
        agentOptions,
        agent,
        statut,
        statutOptions,
        openNewWindow,
        annulationForm,
        retours,
        secteursOptions,
        totalPages,
        soumettre,
        limit,
        format_date,
        format_Date,
        separateur,
        totalElements,
        handlePaginate,
        searchTerm,
        motCle,
        error,
        lemontant,
        checkPermission,
        getPoint,
        valideEtape3,
        getRetourById,
        dateActuelle,
        supprime,
        openModal,
        annulationSchema,
        paiementId,
      };
    },
  });
  </script>